<template>
  <div>
    <div class="application__steps">
      <div class="container">
        <ul>
          <li :class="{ active: step >= 1, current: step === 1}">
            Step 1
          </li>
          <li :class="{ active: step >= 2, current: step === 2}">
            Step 2
          </li>
          <li :class="{ active: step >= 3, current: step === 3}">
            Step 3
          </li>
        </ul>
      </div>
    </div>

    <div class="application__form">
      <div class="container">
        <Error :message="error" />

        <div
          v-if="step === 1"
          class="step step__two"
        >
          <div class="badge">
            <div class="badge-inner">
              Complete your details below to finish your application
            </div>
          </div>

          <form @submit.prevent="submit">
            <p class="title">
              Are you a homeowner?
            </p>

            <ul class="checkboxes-list">
              <li>
                <input
                  id="step-1-homeowner-yes"
                  v-model="data.data1"
                  class="styled-checkbox"
                  type="radio"
                  name="step-1-homeowner"
                  value="YES"
                >
                <label for="step-1-homeowner-yes">YES</label>
              </li>
              <li>
                <input
                  id="step-1-homeowner-no"
                  v-model="data.data1"
                  class="styled-checkbox"
                  type="radio"
                  name="step-1-homeowner"
                  value="NO"
                >
                <label for="step-1-homeowner-no">NO</label>
              </li>
            </ul>

            <div class="form-group">
              <input
                v-model="data['first-name']"
                type="text"
                class="form-control"
                placeholder="First Name"
                minlength="2"
                pattern=".{2,}"
                required
                title="2 characters minimum"
              >
            </div>

            <div class="form-group">
              <input
                v-model="data['last-name']"
                type="text"
                class="form-control"
                placeholder="Last Name"
                minlength="3"
                pattern=".{3,}"
                required
                title="3 characters minimum"
              >
            </div>

            <div class="form-group">
              <input
                v-model="data.email"
                type="email"
                class="form-control"
                placeholder="E-mail Address"
                required
              >
            </div>

            <div class="form-group">
              <input
                v-model="data.phone"
                type="tel"
                class="form-control"
                placeholder="Phone Number"
                minlength="7"
                pattern="(?:\+?44)[0-9]{9}|(?:0)[0-9]{10}"
                required
                title="has to start with 0 or +44 and contain 9-10 numbers"
              >
            </div>


            <input
              v-model="data.postcode"
              type="hidden"
            >

            <button
              class="btn btn-warning btn-lg rounded-pill applicationSubmit2"
              :disabled="sending"
            >
              SUBMIT
              <span
                v-if="sending"
                class="spinner-border spinner-border-sm ml-4"
                role="status"
                aria-hidden="true"
              />
              <i
                v-else
                class="fas fa-angle-right ml-4"
              />
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import URLSearchParams from 'url-search-params';
import { kebabCase } from 'lodash';
import Error from './components/Error.vue';

export default {
  components: { Error },
  props: ['formId', 'resultPageA', 'resultPageB', 'resultPageC', 'resultPageD', 'resultPageE'],
  data() {
    return {
      step: 1,
      stepOneCheckboxes: [
        'Income related Employment Support Allowance',
        'Income based Job Seekers Allowance',
        'Income Support',
        'Pension Guaranteed Credit (excludes Savings Credit)',
        'Working Tax Credit',
        'Universal Credit',
        'Disability Living Allowance',
        'Personal Independence Payment',
        'Attendance Allowance',
        'Carer’s Allowance',
        'Sever Disablement Allowance',
        'Industrial Injuries Disablement Benefits',
        'War Pensions Mobility Supplement',
        'Constant Attendance Allowance',
        'Armed Forces Independence Payment',
        'Child Benefit',
        'None',
      ],
      bedroomRadioboxes: [1, 2, 3, 4, 5, '6+'],
      data: {
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        address: null,
        postcode: null,
      },
      error: '',
      sending: false,
    };
  },
  computed: {
    qualify() {
      return this.data.data1 === 'YES';
    },
    window() {
      return window.base;
    },
    calculatedResultPage() {
      if (this.data.data1 === 'YES') {
        return this.resultPageD;
      }

      return this.resultPageE;
    },
  },

  mounted() {
    const searchParams = new URLSearchParams(window.location.search);

    searchParams.forEach((value, name) => {
      this.data[name] = value;
    });

    if (!this.data.postcode) {
      window.location.href = '/';
    }
  },
  methods: {
    submit() {
      this.sending = true;

      if (window.fbq) {
        window.fbq('track', 'CompleteRegistration');
      }

      if (window.dataLayer) {
        window.dataLayer.push({ event: 'lead' });
      }

      if (this.qualify) {
        if (window.fbq) {
          window.fbq('track', 'Lead');
        }

        if (window.dataLayer) {
          window.dataLayer.push({ event: 'lead-qualified' });
        }
      } else if (window.dataLayer) {
        window.dataLayer.push({ event: 'lead-rejected' });
      }

      $.ajax({
        url: `/wp-json/contact-form-7/v1/contact-forms/${this.formId}/feedback`,
        method: 'POST',
        dataType: 'json',
        data: this.data,
        success: (res) => {
          if (res.status !== 'mail_sent') {
            alert('We unfortunately couldn\'t process your submission. Please try again.');
          }
          this.sending = false;
          window.location.href = this.calculatedResultPage;
        },
        error: () => {
          alert('We unfortunately couldn\'t process your submission. Please try again.');
          this.sending = false;
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~bootstrap/scss/mixins";
  @import "~bootstrap/scss/functions";
  @import "~bootstrap/scss/variables";
  @import "../../sass/common/variables";

  .application {
    &__steps {
      padding: 30px 0 65px;
      color: #fff;
      background: #2c2c2c;

      ul {
        display: flex;
        padding: 0;
        margin: 0;
        list-style: none;
      }

      ul li {
        position: relative;
        flex: 1;
        text-align: center;
      }

      ul li::before {
        position: absolute;
        top: 30px;
        right: 0;
        left: 0;
        z-index: 2;
        display: block;
        width: 20px;
        height: 20px;
        margin: 0 auto 15px auto;
        content: '';
        background: #fff;
        border: 2px solid #fff;
        border-radius: 100%;
      }

      ul li::after {
        position: absolute;
        top: 38px;
        left: -50%;
        z-index: 1;
        display: block;
        width: 100%;
        height: 4px;
        content: '';
        background: #838383;
      }

      ul li:first-child::after {
        content: none;
      }

      ul li.current {
        font-weight: bold;
        color: #ff8e01;

        &::before {
          border-color: #ff8e01;
        }
      }

      ul li.active::after {
        background-image: linear-gradient(to right, rgb(255, 85, 2) 0%, rgb(255, 162, 0) 100%);
      }
    }

    &__form {
      padding: 50px 0;

      @media (max-width: breakpoint-max(sm)) {
        padding: 30px 0;
      }

      .step {
        text-align: center;

        .title {
          margin-bottom: 35px;
          font-weight: bold;

          @include font-size(1.5rem);

          &:not(:first-child) {
            margin-top: 35px;
          }

          small {
            display: block;
          }

          @media (max-width: breakpoint-max(sm)) {
            margin-bottom: 20px;

            &:not(:first-child) {
              margin-top: 20px;
            }
          }

          .title-disclaimer {
            display: block;
            font-size: 1.8rem;
            color: #6b6b6b;
          }
        }

        .custom-label {
          margin-bottom: 25px;
          font-size: 22px;
          color: #6b6b6b;
        }

        .custom-label-big {
          margin-bottom: 25px;

          p:nth-child(1) {
            font-size: 25px;
            font-weight: 700;
            color: #000;
          }
        }
      }
    }
  }

  .radio-buttons {
    margin: 25px 0 40px;

    @media (max-width: breakpoint-max(sm)) {
      margin-bottom: 25px;
    }

    > div {
      display: inline-block;
      vertical-align: top;

      &:not(:last-child) {
        margin-right: 40px;

        @media (max-width: breakpoint-max(sm)) {
          margin-right: 10px;
          margin-bottom: 5px;
        }
      }
    }
  }

  .go-back {
    margin-bottom: 15px;
    color: $color-orange;
    background: transparent;
    border: 0;
    border-bottom: 1px solid $color-orange;
    border-radius: 0;
    transition: all 0.3s ease;

    &:hover {
      color: darken($color-orange, 15);
      border-bottom-color: darken($color-orange, 15);
    }
  }

  ul.checkboxes-list {
    display: flex;
    flex-wrap: wrap;
    padding: 0;
    margin: 0;
    font-size: 0;
    color: #6b6b6b;
    list-style: none;

    li {
      display: flex;
      width: calc(50% - 30px);
      margin: 0 15px 20px;
      font-size: 18px;
      text-align: left;

      @media (max-width: breakpoint-max(sm)) {
        width: 100%;
        margin: 0 0 20px;
      }

      label {
        display: block;
        width: 100%;
        padding: 12px 10px 10px;
        font-weight: 700;
        color: #212121;
        background-color: #fafafa;
        border: 1px solid #bababa;
        border-radius: 5px;
        box-shadow: inset 0 -3px 0 rgba(0, 0, 0, 0.5);

        &::after {
          top: 18px;
          left: 18px;
        }
      }
    }
  }

  .form-group {
    margin-bottom: 18px;
  }

  .form-control {
    display: block;
    width: 100%;
    max-width: 410px;
    height: 55px;
    padding-left: 25px;
    margin: 0 auto;
    font-size: 20px;
    font-weight: 500;
    background-color: #fafafa;
    border: 1px solid #bababa;
    border-radius: 5px;
    box-shadow: inset 0 -3px 0 rgba(0, 0, 0, 0.5);

    &::placeholder {
      color: #212121;
    }
  }

  .badge {
    max-width: 410px;
    margin: 0 auto 30px;
    color: #fff;
    text-align: center;

    .badge-inner {
      position: relative;
      display: inline-block;
      padding: 10px 15px;
      font-size: 16px;
      font-weight: 700;
      text-transform: uppercase;
      background-color: #0f0f0f;
      border-radius: 5px;

      &::after {
        position: absolute;
        bottom: 0;
        left: 50%;
        width: 0;
        height: 0;
        content: "";
        border-color: #0f0f0f transparent transparent transparent;
        border-style: solid;
        border-width: 10px 15px 0 15px;
        transform: translate(-50%, 100%);
      }
    }
  }

  .btn-warning {
    padding-bottom: $btn-padding-y-lg + 0.2rem;
    box-shadow: inset 0 -4px 0 #ff8100;
  }

  .custom-select {
    max-width: 410px;
    margin-right: auto;
    margin-left: auto;
  }
</style>
